import { MedicineBoxOutlined, ReloadOutlined } from '@ant-design/icons';
import type { Order } from '@services/api';
import { Button } from 'antd';
import { useOrderFormContext } from '.';

interface Props {
  order?: Order | null;
}

export default function OrderHeader({ order }: Props) {
  const { reloadOrder, requestHelp } = useOrderFormContext();

  return (
    <div className="row">
      <span className="label">Заявка №</span>{' '}
      {order?.orderNumber}{' '}
      <span className="status">{order?.orderStatus?.title}</span>{' '}
      <Button type="primary" ghost icon={<ReloadOutlined />} onClick={reloadOrder}>Обновить</Button>{' '}
      {requestHelp && <Button type="primary" ghost icon={<MedicineBoxOutlined />} onClick={requestHelp}>Требуется помощь с одобрением</Button>}
    </div>
  );
}
